/* eslint-disable react/jsx-pascal-case */
import React, { Fragment, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';
import { loadDocumentScoringGrids, generateScoring } from '../actionCreators';
import { loadDocumentScoringResult } from '../actionCreatorsAlpha';
import { loadDimensionPeriods } from 'actions/actionCreators/dictionariesActions';
import DocumentScoringResultComponentAlpha from './DocumentScoringResultComponentAlpha';
import DocumentScoringGridContainerAlpha from './DocumentScoringGridContainerAlpha';
import KnockoutCriteriaContainer from 'features/offer/edit/client/knockoutCriteria/components/KnockoutCriteriaContainer';
import { RightsContext } from 'providers/RightsContext';
import {
  getDocumentScoringGrids,
  getDocumentScoringResult,
  getDimensionPeriods,
  getDocumentScoringGridsLoaded,
  getDocumentScoringResultLoaded
} from '../selectors';
import { Grid } from '@mui/material';

export const DocumentScoringContainerAlpha = ({
  actions,
  documentId,
  siteId,
  scoringGrids,
  scoringResult,
  viewScoringHistory,
  dimensionPeriods,
  scoringGridsLoaded,
  scoringResultLoaded,
  isFolder,
  partnerId
}) => {
  const [scoringInProgress, setScoringInProgress] = useState(false);

  const rights = useContext(RightsContext);

  useEffect(() => {
    actions.loadDimensionPeriods();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (hasNoRights()) {
      return;
    }

    loadData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (hasNoRights()) {
      return;
    }

    loadData();
  }, [documentId, siteId, scoringGridsLoaded, scoringResultLoaded, rights]); // eslint-disable-line react-hooks/exhaustive-deps

  const loadData = () => {
    actions.loadDocumentScoringGrids(documentId, siteId);

    if (rights.scoringScoringSummaryRead && isFolder) actions.loadDocumentScoringResult(documentId, siteId);
  };

  const hasNoRights = () => {
    return (
      !rights.scoringScoringSummaryRead &&
      !rights.scoringKoRead &&
      !rights.scoringGridDocumentRead &&
      !rights.scoringGridClientRead &&
      !rights.scoringGridAssetRead
    );
  };

  const generateScoring = async () => {
    if (isFolder) {
      setScoringInProgress(true);
      let event = await actions.generateScoring(documentId, siteId);
      if (event.ok) {
        loadData();
      }
      setScoringInProgress(false);
    }
  };

  return (
    <>
      {rights.scoringScoringSummaryRead && scoringResultLoaded && isFolder && (
        <DocumentScoringResultComponentAlpha
          scoringResult={scoringResult}
          scoringInProgress={scoringInProgress}
          generateScoring={generateScoring}
          viewScoringHistory={viewScoringHistory}
        />
      )}
      <Grid container spacing={1} xs={12}>
        {scoringGridsLoaded &&
          scoringGrids.map(s => (
            <DocumentScoringGridContainerAlpha
              key={s.documentScoringGridId}
              documentId={documentId}
              siteId={siteId}
              scoringGrid={s}
              isHistory={false}
              dimensionPeriods={dimensionPeriods}
              rights={rights}
            />
          ))}
      </Grid>
      {rights.scoringKoRead && (
        <KnockoutCriteriaContainer
          id={'offerClient_KnockoutCriteriaCard'}
          documentId={documentId}
          siteId={siteId}
          partnerId={partnerId}
          disabled={!rights.scoringKoWrite}
        />
      )}
    </>
  );
};

DocumentScoringContainerAlpha.propTypes = {
  actions: PropTypes.object.isRequired,
  documentId: PropTypes.number,
  siteId: PropTypes.number,
  scoringGrids: PropTypes.array,
  scoringResult: PropTypes.object.isRequired,
  dimensionPeriods: PropTypes.array.isRequired,
  scoringGridsLoaded: PropTypes.bool.isRequired,
  scoringResultLoaded: PropTypes.bool.isRequired,
  viewScoringHistory: PropTypes.func.isRequired,
  isFolder: PropTypes.bool.isRequired,
  partnerId: PropTypes.number.isRequired
};

function mapStateToProps(state, route) {
  const key = `${route.documentId}-${route.siteId}`;
  return {
    scoringGrids: getDocumentScoringGrids(state, key),
    scoringGridsLoaded: getDocumentScoringGridsLoaded(state, key),
    scoringResult: getDocumentScoringResult(state, key),
    scoringResultLoaded: getDocumentScoringResultLoaded(state, key),
    dimensionPeriods: getDimensionPeriods(state, key),
    partnerId: state.currentFolder.header.client.partnerId
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ loadDocumentScoringGrids, generateScoring, loadDocumentScoringResult, loadDimensionPeriods }, dispatch),
    dispatch
  };
}

export default withRouter(compose(connect(mapStateToProps, mapDispatchToProps))(DocumentScoringContainerAlpha));
